module.exports = __webpack_public_path__ + "static/media/train2.38f7038e.png";